import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Text, Flex, Button, Divider } from "@chakra-ui/react";

import Topbar from "components/topbar";
import MainLayout from "components/mainLayout";
import { useShipmentForm } from "context/DHLShipmentFormContext";
import { updateLocale } from "moment";

const Pickup = () => {
  const [value, setValue] = useState("dhl_service_point");
  const navigate = useNavigate();
  const { formData, updateFormData } = useShipmentForm();

  return (
    <MainLayout>
      <Flex minH={"100%"} h={"100%"} bg={"#f8fbff"} flexDirection={"column"}>
        <Topbar title={"SHIP THROUGH DHL"} />
        <Flex
          flex={1}
          direction={"column"}
          // justifyContent={"space-between"}
          bg={"#FFFFFF"}
          margin={4}
          padding={6}
          borderRadius={"16px"}
          gap={6}
        >
          {/* <Box> */}
          <Text
            fontFamily={"PlusJakartaSansSemiBold"}
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
            color={"#000000"}
          >
            Create Shipment
          </Text>
          <Divider bg={"#8A8F9333"} h={"1px"} />
          <Box>
            <Box>
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"16px"}
                lineHeight={"20px"}
                color={"#000000"}
              >
                How do you want to provide your shipment to DHL?
              </Text>
              <Flex
                gap={4}
                marginTop={2}
                borderWidth={"1px"}
                borderColor={"#D9D9D9"}
                borderStyle={"solid"}
                padding={4}
                borderRadius={"6px"}
                flexDirection={"column"}
              >
                <Box
                  border="1px solid"
                  borderColor={
                    value === "dhl_service_point" ? "#456EFF" : "gray.300"
                  }
                  bg={value === "dhl_service_point" ? "#456EFF0D" : "white"}
                  borderRadius="4px"
                  p="4"
                  cursor="pointer"
                  onClick={() => setValue("dhl_service_point")}
                >
                  <Flex align="center" justifyContent={"space-between"}>
                    {/* <Radio value="dhl" colorScheme="blue" mr="4" /> */}
                    <Box>
                      <Text
                        fontSize={"16px"}
                        fontFamily={"PlusJakartaSansSemiBold"}
                        color={"#000000"}
                      >
                        Drop off at DHL service point
                      </Text>
                      <Text
                        fontSize={"12px"}
                        fontFamily={"PlusJakartaSansRegular"}
                        color={"#898989"}
                        mt={1}
                      >
                        Drop off the bags in the selected KWC location at your
                        own convenience
                      </Text>
                    </Box>
                  </Flex>
                </Box>
                <Box
                  border="1px solid"
                  borderColor={
                    value === "schedule_courier_pickup" ? "#456EFF" : "gray.300"
                  }
                  bg={
                    value === "schedule_courier_pickup" ? "#456EFF0D" : "white"
                  }
                  borderRadius="4px"
                  p="4"
                  cursor="pointer"
                  onClick={() => setValue("schedule_courier_pickup")}
                >
                  <Flex align="center" justifyContent={"space-between"}>
                    <Box>
                      <Text
                        fontSize={"16px"}
                        fontFamily={"PlusJakartaSansSemiBold"}
                        color={"#000000"}
                      >
                        Schedule a courier pickup
                      </Text>
                      <Text
                        fontSize={"12px"}
                        fontFamily={"PlusJakartaSansRegular"}
                        color={"#898989"}
                        mt={1}
                      >
                        Drop off the bags in the selected KWC location at your
                        own convenience
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              </Flex>
            </Box>
          </Box>
          <Flex mt={4} gap={2} flex={1} alignItems={"flex-end"}>
            <Flex>
              <Button
                onClick={() => navigate(-1)}
                width={"148px"}
                borderRadius={8}
                bg={"none"}
                border={"1px solid #000000"}
                color={"#000000"}
                fontSize={"12px"}
                fontWeight={"500"}
                fontFamily={"PlusJakartaSansMedium"}
                letterSpacing={0.2}
              >
                Back
              </Button>
            </Flex>
            <Flex justifyContent={"flex-end"} flex={1} w={"100%"} gap={2}>
              <Button
                onClick={() => {
                  if (value === "dhl_service_point") {
                    navigate("/send-a-bag/dhl/shipment-to-dhl");
                  }
                  if (value === "schedule_courier_pickup") {
                    updateFormData({
                      type: "pick-up",
                      pickup: {
                        dateAndTime: "",
                        closeTime: "",
                        details: {
                          detailType: "",
                          weight: 0,
                          instruction: "",
                        },
                      },
                    });
                    navigate("/send-a-bag/dhl/label-printing-options");
                  }
                }}
                flex={1}
                maxW={"148px"}
                background={"#000000"}
                color={"#FFFFFF"}
                borderRadius={8}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansMedium"}
                textTransform={"uppercase"}
                // isDisabled={}
                _disabled={{
                  bg: "grey.100",
                  cursor: "default",
                  _hover: {
                    bg: "grey.100",
                    cursor: "default",
                  },
                }}
              >
                Next
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </MainLayout>
  );
};

export default Pickup;
